import axios from "../../axios";

const api = {
  createScopeTwo({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`/supplier-questionnaires/emission-based/${questionnaireId}/scope-two`, data, headers)
      .then(({ data }) => data);
  },

  updateScopeTwo({ questionnaireId, id, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/supplier-questionnaires/emission-based/${questionnaireId}/scope-two/${id}`, data, headers)
      .then(({ data }) => data);
  }
}

export default api;